import classNames from "classnames";
import { RouterConfig } from "@shared/lib/routerConfig";
import { BreadcrumbsArrow } from "@shared/ui/Icon/ui/Common/BreadcrumbsArrow";
import { BreadcrumbsProps } from "./types";
import classes from "./Breadcrumbs.module.scss";

export const Breadcrumbs = ({
    className,
    prevItems,
    title = "Страница не найдена"
}: BreadcrumbsProps) => (
    <nav className={classNames(classes.breadcrumbs, className)} aria-label="breadcrumb">
        <ul className={classes.breadcrumbs__list}>
            <li>
                <a href={RouterConfig.MAIN}>Главная</a>
                <BreadcrumbsArrow className={classes.breadcrumbs__arrow} />
            </li>
            {prevItems?.map((item, index) => (
                <li key={index}>
                    <a href={item.href}>{item.text}</a>
                    <BreadcrumbsArrow className={classes.breadcrumbs__arrow} />
                </li>
            ))}
            <li aria-current="page">{title}</li>
        </ul>
    </nav>
);